export default __webpack_public_path__ + "static/navImg2-fd27e24f43b88230d5b5187a401d4e93.jpg";